import { apiSlice } from '@/api';
import { PriceSummary, SummaryBody, SummaryPriceResponse } from './types';

const summaryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSummaryPrice: builder.mutation<PriceSummary, SummaryBody>({
      query: (body) => ({
        url: 'v1/payment/price-summary',
        method: 'POST',
        body,
      }),
      transformResponse: (response: SummaryPriceResponse) => {
        return response.result;
      },
    }),
  }),
});

export const { useGetSummaryPriceMutation } = summaryApi;
